import styled from 'styled-components';
import { spacing } from 'ui/theme';
import { ExpandableModuleContent } from '../../lib/components/Module';
import { ActivityFeed } from './ActivityFeed';
import { Content } from './ActivityFeed/ActivityFeed';
import { useLaunchpadContext } from './contexts/LaunchpadContext';
import { INITIAL_DISPLAY_MAX_COUNT, LAUNCHPAD_TEST_IDS } from './Launchpad.constants';
import { LaunchpadState } from './Launchpad.types';
import { ErrorState, LoadingState, ZeroState } from './LaunchpadState';

const StyledModuleContent = styled(ExpandableModuleContent)`
  margin: 0 calc(-${spacing.base} - 2px); // -2px to account for the border of the module

  ${Content} {
    padding: 0 ${spacing.base} ${spacing.plusHalf} ${spacing.base};
  }
`;

export const LaunchpadContent = ({
  isLoadingState,
  isErrorState,
  isZeroState,
  isDataState,
}: LaunchpadState) => {
  const {
    activityItems,
    isExpanded,
    setIsExpanded,
    handleLoadMore,
    handleRetry,
    activityItemsCount,
    handleClearFilters,
    isLoadingMore,
  } = useLaunchpadContext();

  const handleViewMoreClick = () => {
    setIsExpanded(!isExpanded);
    handleLoadMore();
  };

  switch (true) {
    case isLoadingState:
      return <LoadingState initialDisplayMax={INITIAL_DISPLAY_MAX_COUNT} />;

    case isErrorState:
      return <ErrorState onRetry={handleRetry} />;

    case isZeroState:
      return <ZeroState onClear={handleClearFilters} />;

    case isDataState:
      return (
        <StyledModuleContent
          data-test={LAUNCHPAD_TEST_IDS.CONTENT}
          isExpanded={isExpanded}
          showViewMore={activityItemsCount > INITIAL_DISPLAY_MAX_COUNT}
          onViewMoreClick={handleViewMoreClick}
          isLoadingMore={isLoadingMore}
        >
          <ActivityFeed
            activityItems={
              isExpanded ? activityItems : activityItems.slice(0, INITIAL_DISPLAY_MAX_COUNT)
            }
          />
        </StyledModuleContent>
      );

    default:
      return null;
  }
};
